export default "__VITE_ASSET__e4e0ecfa__"